export default __webpack_public_path__ + "static/media/telegram-icon.d97b2714.svg";